var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPopupIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 4,
    viewBox: "0 0 8 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.06884 0.372478C1.28102 0.16518 1.6197 0.164609 1.83257 0.371191L4.00008 2.47467L6.16759 0.371191C6.38046 0.164609 6.71915 0.16518 6.93132 0.372478C7.15164 0.587732 7.15103 0.942315 6.92999 1.15682L4.00008 4L1.07018 1.15682C0.849129 0.942315 0.848527 0.587732 1.06884 0.372478Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopupIcon);
export default __webpack_public_path__ + "static/media/popupIcon.cde120702314b796f0e0f616199a4c51.svg";
export { ForwardRef as ReactComponent };